import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { getOfflineActiveStepNumber1, offlineTransferPhaseData1 } from "../../../../utils";
import { TransferPhasebar } from "../../../ui/TransferPhasebar";

export const OfflineTransferPhaseLayout1 = () => {
  const location = useLocation();

  const [activeStepNumber, setActiveStepNumber] = React.useState<number>(1);

  React.useEffect(() => {
    setActiveStepNumber(getOfflineActiveStepNumber1(location.pathname, activeStepNumber));
  }, [location.pathname]);

  return (
    <div className="flex">
      <TransferPhasebar
        transactionMode="Offline"
        data={offlineTransferPhaseData1}
        activeStepNumber={activeStepNumber}
      />
      <div className="ml-[379px] w-screen h-screen">
        <Outlet />
      </div>
    </div>
  );
};
